
import { DashboardKeys } from '@/i18n/types/dashboard.types';

export const dashboard: Record<DashboardKeys, string> = {
  overdueTasks: 'Tareas Pendientes',
  todayTasks: 'Tareas para Hoy',
  specialDates: 'Fechas Especiales',
  todaySchedule: 'Agenda de Hoy',
  todayPayments: 'Pagos de Hoy',
  todayIncome: 'Ingresos de Hoy',
  overdueDebts: 'Deudas Vencidas',
  todayDebts: 'Deudas para Hoy',
  noOverdueTasks: 'No hay tareas pendientes',
  noTodayTasks: 'No hay tareas para hoy',
  noSpecialDates: 'No hay fechas especiales hoy',
  noScheduledEvents: 'No hay eventos programados',
  noOverdueDebts: 'No hay deudas vencidas',
  noTodayDebts: 'No hay deudas para hoy',
  loadingTasks: 'Cargando tareas...',
  selectMonth: 'Seleccionar mes',
  specialDateDeleted: 'Fecha especial eliminada correctamente',
  errorDeletingSpecialDate: 'Error al eliminar la fecha especial',
  noTodayPayments: 'No hay pagos para hoy',
  noIncome: 'No hay ingresos para hoy',
  goals: 'Metas',
  activeGoals: 'Metas Activas',
  noActiveGoals: 'No hay metas activas',
  habitsToday: 'Hábitos de Hoy',
  dailyHabits: 'Hábitos Diarios',
  noHabitsToday: 'No hay hábitos para hoy',
  calendarAndEvents: 'Calendario y Eventos',
  financeOverview: 'Resumen Financiero',
  reminders: 'Recordatorios',
  overdueReminders: 'Recordatorios Vencidos',
  todayReminders: 'Recordatorios de Hoy',
  upcomingReminders: 'Próximos Recordatorios',
  noOverdueReminders: 'No hay recordatorios vencidos',
  noTodayReminders: 'No hay recordatorios para hoy',
  noUpcomingReminders: 'No hay próximos recordatorios',
  tasksAndGoals: 'Tareas y Metas'
};
